import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { WishlistCmsComponents } from '@core/const';
import { SdvorSpinnerComponent } from '@sdvor/shared/ui';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { WishlistContentEmptyModule } from './wishlist-content-empty/wishlist-content-empty.module';
import { WishlistContentEntriesModule } from './wishlist-content-entries/wishlist-content-entries.module';
import { WishlistContentErrorModule } from './wishlist-content-error/wishlist-content-error.module';
import { WishlistContentComponent } from './wishlist-content.component';

@NgModule({
  imports: [
    AsyncPipe,
    NgIf,
    SdvorSpinnerComponent,
    WishlistContentEmptyModule,
    WishlistContentErrorModule,
    WishlistContentEntriesModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        [WishlistCmsComponents.RosaCMSWishlistContentComponent]: {
          component: WishlistContentComponent,
        },
      },
    }),
  ],
  declarations: [WishlistContentComponent],
  exports: [WishlistContentComponent],
})
export class WishlistContentModule {}
